export default __webpack_public_path__ + "static/media/undraw_collecting.dda085b0.png";